module.exports = __webpack_public_path__ + "images/twitter-fa1dc935b6f87d87d9d910bdb9375f08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/social/twitter.jpg
// module id = 739
// module chunks = 0